// TaskMaster order (26 Oct 2026), the same rule as MBTS (src/database/todoList.js):
// emergencies first, then the rest, each oldest first. A to-do without a date
// counts from when it was created (its _id); one added just now goes last in its group.
const addedAt = (t) => {
  const d = t && t.dateAdded ? new Date(t.dateAdded).getTime() : NaN;
  if (Number.isFinite(d)) return d;
  const id = String((t && t._id) || "");
  return /^[0-9a-f]{24}$/i.test(id) ? parseInt(id.slice(0, 8), 16) * 1000 : Number.MAX_SAFE_INTEGER;
};

export const sortTodos = (items) =>
  [...(items || [])].sort((a, b) => (Number(!!b.isEmergency) - Number(!!a.isEmergency)) || (addedAt(a) - addedAt(b)));
